import React from "react";
import { useTranslation } from "react-i18next";

export default function About_text() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full justify-center items-center py-8 px-4">
      <div className="flex flex-col w-full max-w-7xl gap-6">
        {/* Header Section */}
        <div className="w-full">
          <h1 className="text-4xl font-semibold mb-4 md:mb-8">
            {t("aboutText.header")}
          </h1>
        </div>

        {/* Content Section */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-10 w-full">
          {/* Left Column */}
          <div className="md:w-1/2 text-gray-700 leading-relaxed">
            {t("aboutText.leftColumn")}
          </div>

          {/* Right Column */}
          <div className="md:w-1/2 text-gray-700 leading-relaxed">
            {t("aboutText.rightColumn")}
          </div>
        </div>
      </div>
    </div>
  );
}
